import { render, staticRenderFns } from "./LifetimeFaqSection.vue?vue&type=template&id=7dd4277a&scoped=true"
import script from "./LifetimeFaqSection.vue?vue&type=script&lang=js"
export * from "./LifetimeFaqSection.vue?vue&type=script&lang=js"
import style0 from "./LifetimeFaqSection.vue?vue&type=style&index=0&id=7dd4277a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd4277a",
  null
  
)

export default component.exports